import React, { useState, useEffect } from 'react'
import { useHistory, withRouter, Redirect } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { departamentsActions } from '../../../actions/departamentsActions'
import { routes } from '../../../constantes/routes'
import NewDepartamentsModal from './NewDepartamentsModal'
import EditDepartamentsModal from './EditDepartamentsModal'
import DepartamentsList from './DepartamentsList'
import PlusBtn from '../../buttons/PlusBtn'
import {
  swalAlertIsConfirm,
  swalAlertError,
  swalSuccessGeneral,
} from '../../../utils/swalAlert'
import { swalTitle } from '../../../constantes/swalTitle'
import { onSubmitText } from '../../../constantes/onSubmitText'
import Search from '../../common/Search'
import Header from '../../header/Header'
import validators from '../../../utils/validationsRegEx'
import { departamentsTypes } from '../../../constantes/actionTypes'
import { swalMssgs } from '../../../constantes/swalMssgs'

const DepartamentsContainer = () => {
  const history = useHistory()

  const userProfile = useSelector((state) => state.userProfile)
  const allDepartaments = useSelector((state) => state.departaments)

  const [newDepartament, setNewDepartament] = useState({ nombre: '' })
  const [editDepartament, setEditDepartament] = useState({ nombre: '' })
  const [modalIsOpen, setIsOpen] = useState({
    createModal: false,
    editModal: false,
  })

  const [items, setItems] = useState(allDepartaments)

  const dispatch = useDispatch()
  const getAllDepartaments = () =>
    dispatch(departamentsActions.getAllDepartaments())
  const newDepartment = (department) =>
    dispatch(departamentsActions.newDepartament(department))
  const updateDepartment = (department) =>
    dispatch(departamentsActions.updateDepartament(department))
  const deleteDepartment = (idDepartament) =>
    dispatch(departamentsActions.deleteDepartament(idDepartament))

  useEffect(() => {
    if (userProfile.roles.isBackofficeVer) {
      getAllDepartaments()
    }
  }, [])

  useEffect(() => {
    setItems(allDepartaments)
  }, [allDepartaments])

  const openNewModal = () => {
    setIsOpen({
      createModal: true,
      editModal: false,
    })

    setNewDepartament({ nombre: '' })
  }

  const openEditModal = (idDepartament) => {
    setIsOpen({
      createModal: false,
      editModal: true,
    })
    setEditDepartament(
      items.find((item) => item.id_TipoDepartamento === idDepartament),
    )
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  const handleNew = async (event) => {
    event.preventDefault()
    try {
      const response = await newDepartment(newDepartament)
      if (departamentsTypes.NEW_DEPARTAMENT_SUCCESS === response.type) {
        swalSuccessGeneral(swalTitle.CreadoCorrectamente, swalMssgs.NEW_SUCCES)
        closeModal()
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  const handleRemove = async (idDepartament) => {
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quieres eliminar este departamento?',
      )
      if (alert.isConfirmed) {
        const response = await deleteDepartment(idDepartament)
        if (departamentsTypes.DELETE_DEPARTAMENT_SUCCESS === response.type)
          swalSuccessGeneral(swalTitle.Eliminado, swalMssgs.DELETE_SUCCESS)
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  const handleEdit = async (event) => {
    event.preventDefault()
    try {
      const response = await updateDepartment(editDepartament)
      if (departamentsTypes.UPDATE_DEPARTAMENT_SUCCESS === response.type) {
        swalSuccessGeneral(swalTitle.Actualizado, swalMssgs.UPDATE_SUCCES)
        closeModal()
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  const handleChangeNew = (e) => {
    const name = e.target.name
    const value = e.target.value

    setNewDepartament({ [name]: value })
  }

  const handleChangeEdit = (e) => {
    const name = e.target.name
    const value = e.target.value

    setEditDepartament((dept) => ({ ...dept, [name]: value }))
  }

  const validateFormNew = () => {
    return validators.hasValue(newDepartament.nombre)
  }

  const validateFormEdit = () => {
    return validators.hasValue(editDepartament.nombre)
  }

  const toBackoffice = () => {
    history.push(routes.BACKOFFICE)
  }

  const onChangeSearch = (value) => {
    const newItems = allDepartaments.filter((item) =>
      item.nombre.toLowerCase().includes(value.toLowerCase()),
    )
    setItems(newItems)
  }

  return (
    <>
      {userProfile.roles.isBackofficeVer ? (
        <div className='products'>
          <Header text={'Departamentos'} route={toBackoffice} backBtn={true} />
          <div className='filter__wrap mb-80'>
            <Search
              onChangeSearch={onChangeSearch}
              placeholder='Buscar por nombre...'
            />
            <div className='add__action__rigth__side'>
              <button className='action-button' onClick={openNewModal}>
                <PlusBtn />
                <span>Nuevo departamento</span>
              </button>
            </div>
          </div>
          <DepartamentsList
            allDepartaments={items}
            handleRemove={handleRemove}
            userProfile={userProfile}
            openEditModal={openEditModal}
          />
          <NewDepartamentsModal
            newDepartament={newDepartament}
            modalIsOpen={modalIsOpen.createModal}
            closeModal={closeModal}
            handleSubmit={handleNew}
            handleChange={handleChangeNew}
            validateForm={validateFormNew}
            textBtn={onSubmitText.Crear}
          />
          <EditDepartamentsModal
            inputs={editDepartament}
            modalIsOpen={modalIsOpen.editModal}
            closeModal={closeModal}
            handleSubmit={handleEdit}
            handleChange={handleChangeEdit}
            validateForm={validateFormEdit}
            textBtn={onSubmitText.Guardar}
          />
        </div>
      ) : (
        <Redirect to={{ pathname: routes.MAIN }} />
      )}
    </>
  )
}
export default withRouter(DepartamentsContainer)
